import SalarieVilleNaissance from '@/generated/controls/salarie/SalarieVilleNaissance.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: SalarieVilleNaissance
})
